// Legacy ball positioning for older pitch data without relative coordinates.
// Replicates production's position formula and bounds-check strike/ball determination.

interface FallbackBallPositionParams {
  plateLocSideFeet: number;
  plateLocHeightFeet: number;
  zoneAccuracy?: string;
  perspective: "pitcher" | "catcher";
  isSoftball: boolean;
}

export interface FallbackBallPosition {
  ballX: number;
  ballY: number;
  isStrike: boolean;
}

const SOFTBALL_HEIGHT_ADJUSTMENT = 161;
const BASEBALL_HEIGHT_ADJUSTMENT = 184;

// Bounds in the same 0-100 percentage space as ballX/ballY, ported from
// production's StrikeZoneVisualization.tsx
const SOFTBALL_ZONE_BOUNDS = { xMin: -6, xMax: 109, yMin: -6.4, yMax: 106.4 };
const BASEBALL_ZONE_BOUNDS = { xMin: -4, xMax: 106, yMin: -5, yMax: 104 };

export function getFallbackBallPosition({
  plateLocSideFeet,
  plateLocHeightFeet,
  zoneAccuracy,
  perspective,
  isSoftball,
}: FallbackBallPositionParams): FallbackBallPosition | undefined {
  if (zoneAccuracy !== "high") return undefined;

  const multiplier = perspective === "pitcher" ? 57.95 : -57.95;
  const heightAdjustment = isSoftball
    ? SOFTBALL_HEIGHT_ADJUSTMENT
    : BASEBALL_HEIGHT_ADJUSTMENT;

  const ballX = multiplier * plateLocSideFeet + 50;
  const ballY = -54 * plateLocHeightFeet + heightAdjustment;

  const { xMin, xMax, yMin, yMax } = isSoftball
    ? SOFTBALL_ZONE_BOUNDS
    : BASEBALL_ZONE_BOUNDS;
  const isStrike =
    ballX >= xMin && ballX <= xMax && ballY >= yMin && ballY <= yMax;

  return { ballX, ballY, isStrike };
}
